module.exports = __webpack_public_path__ + "img/iconVisa2.13938ecf.png";